
const gemStones = [
    "Alexandrite",
    "Alexandrite Cats Eye",
    "Almandine Garnet",
    "Amber",
    "Amethyst",
    "Amethyst Cabochon",
    "Ametrine",
    "Ammolite",
    "Andalusite",
    "Andesine",
    "Andesine Labradorite",
    "Angel Skin Coral",
    "Apatite",
    "Apatite Cat's Eye",
    "Aquamarine",
    "Australian Opal",
    "Aventurine",
    "Azurite",
    "Basra Pearls",
    "Beryl",
    "Bicolor Sapphire",
    "Bixbite",
    "Black Onyx",
    "Black Opal",
    "Black Pearls",
    "Black Spinel",
    "Black Tourmaline",
    "Blizzard Stone",
    "Bloodstone",
    "Blue Fluorite",
    "Blue Moonstone",
    "Blue Opal",
    "Blue Sapphire",
    "Blue Spinel",
    "Blue Topaz",
    "Blue Tourmaline/Indicolite Tourmaline",
    "Blue Zircon",
    "Boulder Opal",
    "Brazilian Emerald",
    "Brown Moonstone",
    "Brown Zircon",
    "Burmese Ruby",
    "Burmese Sapphire",
    "Carnelian",
    "Cats Eye",
    "Cats Eye Moonstone",
    "Cats Eye Opal",
    "Cats Eye Quartz",
    "Ceylon Blue Sapphire ",
    "Chrome Diopside",
    "Chrome Tourmaline",
    "Chrysoberyl",
    "Chrysoberyl Cat’s Eye",
    "Chrysocolla",
    "Citrine (Sunela)",
    "Clinohumite",
    "Colombian Emerald",
    "Color Change Fluorite",
    "Color Change Sapphire",
    "Cornflower Blue Sapphire",
    "Cubic Zirconia",
    "Cultured Pearls",
    "Danburite",
    "Demantoid Garnet",
    "Diopside",
    "Emerald (Panna)",
    "Ethiopian Emerald",
    "Ethiopian Opal",
    "Fire Agate",
    "Fire Opal",
    "Fluorite",
    "Freshwater Pearls",
    "Garnet",
    "Glass Filled Ruby",
    "Golden Sapphire",
    "Golden Topaz",
    "Goshenite",
    "Grandidierite",
    "Green Amethyst",
    "Green Apatite",
    "Green Garnet",
    "Green Kyanite",
    "Green Sapphire",
    "Green Tanzanite",
    "Green Tourmaline",
    "Grey Sapphire",
    "Heliodor",
    "Hessonite",
    "Imperial Topaz",
    "Indian Emerald",
    "Indian Ruby",
    "Indraneelam",
    "Insignificant Oil Emerald",
    "Iolite",
    "Iranian Turquoise",
    "Jade",
    "Jade Nephrite",
    "Jadeite",
    "Japanese Red Coral",
    "Jasper",
    "Kashmir Blue Sapphire",
    "Keshi Pearls",
    "Khooni Neelam",
    "Kunzite",
    "Kyanite",
    "Labradorite ",
    "Lapis Lazuli",
    "Lavender Quartz",
    "Lemon Quartz",
    "London Blue Topaz",
    "Malachite",
    "Mandarin Garnet",
    "Mexican Fire Opal",
    "Mocha Scapolite",
    "Mogok Ruby ",
    "Moldavite",
    "Monazite",
    "Moonstone",
    "Morganite",
    "Moss Agate",
    "Mozambique Ruby",
    "Natural Pearls",
    "Navratna",
    "Neon Apatite",
    "No Oil Emerald",
    "Obsidian",
    "Onyx",
    "Opal",
    "Opal Doublet",
    "Orange Kyanite",
    "Orange Sapphire",
    "Orthoclase",
    "Padparadscha Sapphire",
    "Pakistan Emerald/Swat Emerald",
    "Panjshir Emerald",
    "Paraiba Tourmaline",
    "Peach Morganite",
    "Peach Sapphire",
    "Peacock Tanzanite",
    "Pearl",
    "Peridot",
    "Persian Turquoise",
    "Petalite",
    "Petrified Wood",
    "Pigeon Blood Ruby",
    "Pink Coral",
    "Pink Fluorite",
    "Pink Morganite",
    "Pink Opal",
    "Pink Sapphire",
    "Pink Spinel",
    "Pink Topaz",
    "Pink Tourmaline",
    "Pitambari Neelam",
    "Prehnite",
    "Purple Garnet",
    "Purple Sapphire",
    "Rainbow Fluorite",
    "Rainbow Moonstone",
    "Red Coral",
    "Red Spinel",
    "Red Tourmaline",
    "Red Zircon",
    "Rhodochrosite",
    "Rhodonite ",
    "Rose Quartz",
    "Royal Blue Sapphire",
    "Rubellite",
    "Ruby (Manik)",
    "Ruby Cabochon",
    "Russian Alexandrite",
    "Russian Emerald",
    "Rutilated Quartz",
    "Sang-E-Maryam",
    "Sapphire",
    "Schorl Tourmaline",
    "Serpentine",
    "Sillimanite Cats Eye",
    "Sky Blue Topaz",
    "Smoky Quartz",
    "Sodalite",
    "South Sea Pearls",
    "Spectrolite",
    "Spessartite",
    "Sphalerite",
    "Spinel",
    "Sri Lanka Moonstone",
    "Star Garnet",
    "Star Ruby",
    "Star Sapphire",
    "Sunstone",
    "Swiss Blue Topaz",
    "Taaffeite",
    "Tahitian Pearls",
    "Tanzania Ruby",
    "Tanzanite",
    "Teal Sapphire",
    "Tibetian Turquoise ",
    "Tiger Eye",
    "Titanite",
    "Topaz",
    "Tourmaline",
    "Trapiche Emerald",
    "Tsavorite",
    "Turquoise",
    "Violet Sapphire",
    "Vivid Green Emerald",
    "Watermelon Tourmaline",
    "White Coral",
    "White Opal",
    "White Sapphire",
    "White Topaz",
    "White Zircon",
    "Yellow Beryl",
    "Yellow Fluorite",
    "Yellow Sapphire",
    "Yellow Topaz",
    "Yellow Zircon",
    "Zambian Emerald",
    "Zircon",
    "Zultanite",
]

const colors = [
    "Baker-Miller pink",
    "Bright yellow",
    "Amber",
    "Atomic tangerine",
    "Bisque",
    "Candy apple red",
    "Baby powder",
    "Coquelicot",
    "Blanched almond",
    "Brilliant rose",
    "Bittersweet",
    "Cadmium yellow",
    "Canary yellow",
    "Carnation pink",
    "Canary",
    "Cherry blossom pink",
    "Coral",
    "Chinese yellow",
    "Chrome yellow",
    "Cyber yellow",
    "Deep pink",
    "Aureolin",
    "Banana Mania",
    "Cotton candy",
    "Cream",
    "Cosmic latte",
    "Cornsilk",
    "Dark orange",
    "Deep saffron",
    "Floral white",
    "Fiery rose",
    "French pink",
    "Fuchsia",
    "French fuchsia",
    "Antique white",
    "Blond",
    "Brink pink",
    "Apricot",
    "Corn",
    "Coral pink",
    "Cultured",
    "Cameo pink",
    "Champagne",
    "Flickr Pink",
    "Deep champagne",
    "Congo pink",
    "Champagne pink",
    "Baby pink",
    "Beige",
    "French rose",
    "Cyclamen",
    "Azure",
    "Alice blue",
    "Fashion fuchsia",
    "Almond",
    "Eggshell",
    "Dutch white",
    "Amaranth pink",
    "Buff",
    "Desert sand",
    "Cadmium orange",
    "Arylide yellow",
    "Fire opal",
    "Alabaster",
    "Carrot orange",
    "Flax",
    "Burnt sienna",
    "Cadmium red",
    "Dark salmon",
    "Flame",
    "Bone",
    "Amaranth",
    "Frostbite",
    "Fulvous",
    "Charm pink",
    "Candy pink",
    "Fawn",
    "Citrine",
    "Cinnabar",
    "CG red",
    "Crimson",
    "Earth yellow",
    "China pink",
    "Blush",
    "Chartreuse",
    "Burlywood",
    "Cerise",
    "Barbie Pink",
    "Fandango pink",
    "Deep cerise",
    "Chocolate",
    "Bright lilac",
    "Dogwood rose",
    "Carmine",
    "Copper",
    "Amaranth red",
    "French mauve",
    "Cocoa brown",
    "Arctic lime",
    "Fire engine red",
    "Cedar Chest",
    "Camel",
    "Burnt orange",
    "French raspberry",
    "Aero blue",
    "Bitter lemon",
    "Cinnamon Satin",
    "Bright maroon",
    "Desert",
    "Fuchsia purple",
    "English vermillion",
    "Antique brass",
    "Bronze",
    "Electric lime",
    "Fuchsia rose",
    "Brick red",
    "Alloy orange",
    "Copper red",
    "Cardinal",
    "Bitter lime",
    "English lavender",
    "Celeste",
    "Dark khaki",
    "Fallow",
    "Ecru",
    "Bittersweet shimmer",
    "Beau blue",
    "Black Shadows",
    "Electric purple",
    "Byzantine",
    "Columbia Blue",
    "Dark goldenrod",
    "Deep chestnut",
    "Carnelian",
    "African violet",
    "Fandango",
    "Ash gray",
    "Copper penny",
    "Auburn",
    "Celadon",
    "Acid green",
    "Amaranth purple",
    "Brown sugar",
    "Blue bell",
    "Firebrick",
    "Chinese red",
    "English red",
    "Café au lait",
    "Cadet blue",
    "Blizzard blue",
    "China rose",
    "French beige",
    "Blast-off bronze",
    "Flirt",
    "Android green",
    "Cambridge blue",
    "Baby blue eyes",
    "Cinereous",
    "Drab",
    "Citron",
    "Beaver",
    "Cadet grey",
    "Burnished brown",
    "Big dip o’ruby",
    "French lime",
    "Amethyst",
    "Copper rose",
    "Eton blue",
    "Bistre brown",
    "Dark orchid",
    "Dark violet",
    "Artichoke",
    "Chestnut",
    "Antique fuchsia",
    "Dark sea green",
    "Baby blue",
    "Cool grey",
    "Dark magenta",
    "Cordovan",
    "Dark sky blue",
    "Apple green",
    "Brown",
    "Asparagus",
    "Brandy",
    "Electric violet",
    "Blue-violet",
    "Burnt umber",
    "Dark red",
    "French violet",
    "French lilac",
    "Fuzzy Wuzzy",
    "Antique ruby",
    "Battleship grey",
    "Chinese violet",
    "Aero",
    "Coyote brown",
    "Byzantium",
    "Aquamarine",
    "French bistre",
    "Burgundy",
    "Deep taupe",
    "Falu red",
    "Barn red",
    "Claret",
    "French sky blue",
    "Electric blue",
    "Bole",
    "Coffee",
    "Air superiority blue",
    "Bud green",
    "Catawba",
    "Cornflower blue",
    "Electric indigo",
    "Eminence",
    "Blue-gray",
    "Field drab",
    "Blood red",
    "Cerulean frost",
    "Dim gray",
    "Bright green",
    "Dark blue-gray",
    "Cyber grape",
    "Caput mortuum",
    "Eggplant",
    "Dark byzantium",
    "Antique bronze",
    "Forest green",
    "Dark brown",
    "Avocado",
    "Blue jeans",
    "Dark electric blue",
    "Dark liver",
    "Café noir",
    "Emerald",
    "Carolina blue",
    "Cadet",
    "English violet",
    "Dark olive green",
    "Black coral",
    "Blue yonder",
    "Ebony",
    "Davy's grey",
    "Army green",
    "Feldgrau",
    "Fern green",
    "Dark moss green",
    "Dark lava",
    "Deep Space Sparkle",
    "Dark slate blue",
    "Black bean",
    "Bistre",
    "Black olive",
    "Bluetiful",
    "B'dazzled blue",
    "Charcoal",
    "Cerulean blue",
    "Cosmic cobalt",
    "Celadon green",
    "Black coffee",
    "Amazon",
    "Dark sienna",
    "Blue",
    "Dark slate gray",
    "Dark cornflower blue",
    "Bleu de France",
    "Dark purple",
    "Celtic blue",
    "Charleston green",
    "Dodger blue",
    "Blue-green",
    "Denim",
    "Eerie black",
    "Denim blue",
    "Flickr Blue",
    "Black chocolate",
    "English green",
    "Brunswick green",
    "Cerulean",
    "Fluorescent blue",
    "Bright navy blue",
    "Dark jungle green",
    "Dark spring green",
    "Egyptian blue",
    "Blue sapphire",
    "Dark pastel green",
    "Absolute Zero",
    "Black",
    "Cadmium green",
    "British racing green",
    "Cobalt blue",
    "Bottle green",
    "Castleton green",
    "Aqua",
    "Ao",
    "Capri",
    "Caribbean green",
    "CG blue",
    "Celadon blue",
    "Cyan",
    "Dark green",
    "Dark cyan",
    "Gamboge",
    "Dark turquoise",
    "Gainsboro",
    "Deep jungle green",
    "French blue",
    "Duke blue",
    "Deep sky blue",
    "Dartmouth green",
    "Erin",
    "Electric green",
    "Glossy grape",
    "Glaucous",
    "Ghost white",
    "Generic viridian",
    "GO green",
    "Gold Fusion",
    "Gold",
    "Green",
    "Golden poppy",
    "Gray",
    "Goldenrod",
    "Granite gray",
    "Golden yellow",
    "Golden brown",
    "Granny Smith apple",
    "Green-cyan",
    "Green-blue",
    "Grullo",
    "Green Sheen",
    "Green-yellow",
    "Green Lizard",
    "Harlequin",
    "Hansa yellow",
    "Han purple",
    "Han blue",
    "Gunmetal",
    "Heliotrope",
    "Heliotrope gray",
    "Harvest gold",
    "Hollywood cerise",
    "Heat Wave",
    "Hot pink",
    "Hot magenta",
    "Honeydew",
    "Honolulu blue",
    "Hooker's green",
    "Iceberg",
    "Illuminating emerald",
    "Icterine",
    "Imperial red",
    "Hunter green",
    "Independence",
    "Indian yellow",
    "India green",
    "Inchworm",
    "Indian red",
    "Indigo dye",
    "Indigo",
    "International orange",
    "International Klein Blue",
    "International orange (Golden Gate",
    "Iris",
    "Ivory",
    "Jade",
    "Keppel",
    "Jungle green",
    "Jasmine",
    "Kelly green",
    "Jet",
    "Irresistible",
    "Italian sky blue",
    "Isabelline",
    "Jazzberry jam",
    "June bud",
    "Jonquil",
    "Key lime",
    "Khaki (X11)",
    "Kobe",
    "Khaki",
    "Kobi",
    "Lapis lazuli",
    "Laurel green",
    "Lavender blush",
    "KSU purple",
    "Kobicha",
    "Languid lavender",
    "Lemon curry",
    "Kombu green",
    "Lava",
    "Lavender",
    "Laser lemon",
    "Lemon",
    "Lavender blue",
    "Lavender gray",
    "Lawn green",
    "Lemon chiffon",
    "Lemon yellow",
    "Lemon glacier",
    "Lemon meringue",
    "Light cornflower blue",
    "Light gray",
    "Light salmon",
    "Liberty",
    "Light coral",
    "Light blue",
    "Light yellow",
    "Light French beige",
    "Light goldenrod yellow",
    "Light cyan",
    "Light green",
    "Light sea green",
    "Light orange",
    "Light pink",
    "Light periwinkle",
    "Light steel blue",
    "Light sky blue",
    "Light slate gray",
    "Lilac",
    "Lilac Luster",
    "Little boy blue",
    "Linen",
    "Lime",
    "Lincoln green",
    "Liver",
    "Liseran purple",
    "Lion",
    "Lime green",
    "Lime (web)",
    "Liver chestnut",
    "Livid",
    "Macaroni and Cheese",
    "Madder Lake",
    "Magenta",
    "Mahogany",
    "Magenta haze",
    "Magic mint",
    "Magnolia",
    "Malachite",
    "Maize",
    "Majorelle blue",
    "Manatee",
    "Maroon",
    "Mardi Gras",
    "Mantis",
    "Mango",
    "Mandarin",
    "Mango Tango",
    "Mauve",
    "Marigold",
    "Maximum blue purple",
    "Medium aquamarine",
    "Maximum red purple",
    "Maximum blue",
    "Maximum blue green",
    "Medium orchid",
    "Mauve taupe",
    "Mauvelous",
    "Maximum red",
    "Maximum green",
    "Maximum purple",
    "Maximum green yellow",
    "Maximum yellow",
    "Maya blue",
    "May green",
    "Maximum yellow red",
    "Medium candy apple red",
    "Medium carmine",
    "Medium blue",
    "Medium champagne",
    "Medium slate blue",
    "Medium sea green",
    "Medium purple",
    "Medium spring green",
    "Medium turquoise",
    "Mellow apricot",
    "Mellow yellow",
    "Melon",
    "Medium violet-red",
    "Metallic gold",
    "Metallic Seaweed",
    "Metallic Sunburst",
    "Middle blue",
    "Middle blue green",
    "Mexican pink",
    "Middle blue purple",
    "Middle green",
    "Middle grey",
    "Middle purple",
    "Middle green yellow",
    "Middle yellow",
    "Middle red purple",
    "Middle red",
    "Midnight",
    "Middle yellow red",
    "Midnight blue",
    "Mimi pink",
    "Mindaro",
    "Mikado yellow",
    "Midnight green",
    "Mint cream",
    "Mint green",
    "Mint",
    "Minion yellow",
    "Ming",
    "Morning blue",
    "Mode beige",
    "Misty moss",
    "Moss green",
    "Misty rose",
    "Mountain Meadow",
    "Mountbatten pink",
    "Mulberry",
    "MSU green",
    "Mystic maroon",
    "Mystic",
    "Mustard",
    "Nadeshiko pink",
    "Myrtle green",
    "Navajo white",
    "Navy blue",
    "Naples yellow",
    "Neon blue",
    "Neon green",
    "Non-photo blue",
    "New York pink",
    "Nyanza",
    "Nickel",
    "Ocean Blue",
    "Ochre",
    "Ocean green",
    "Old gold",
    "Old burgundy",
    "Old lace",
    "Old silver",
    "Old rose",
    "Old lavender",
    "Olive",
    "Old mauve",
    "Olive Drab",
    "Olive green",
    "Olivine",
    "Orange",
    "Olive Drab #7",
    "Onyx",
    "Opal",
    "Opera mauve",
    "Orange-red",
    "Orange peel",
    "Orange-yellow",
    "Orchid pink",
    "Orange soda",
    "Orchid",
    "Oxford blue",
    "Outrageous Orange",
    "Outer space",
    "Oxblood",
    "Pale aqua",
    "Pacific blue",
    "Pakistan green",
    "OU Crimson red",
    "Palatinate purple",
    "Pale spring bud",
    "Pale pink",
    "Pale silver",
    "Pale purple",
    "Pale cerulean",
    "Paolo Veronese green",
    "Pansy purple",
    "Paradise pink",
    "Paris Green",
    "Papaya whip",
    "Pastel pink",
    "Peach",
    "Payne's grey",
    "Patriarch",
    "Peach puff",
    "Pear",
    "Pearly purple",
    "Periwinkle",
    "Permanent Geranium Lake",
    "Persian green",
    "Persian orange",
    "Persian indigo",
    "Persian blue",
    "Pine green",
    "Persian plum",
    "Persian rose",
    "Persian red",
    "Pewter Blue",
    "Persian pink",
    "Phlox",
    "Persimmon",
    "Phthalo green",
    "Picotee blue",
    "Pink",
    "Phthalo blue",
    "Pictorial carmine",
    "Piggy pink",
    "Pine tree",
    "Pistachio",
    "Prussian blue",
    "Pink Sherbet",
    "Pink flamingo",
    "Powder blue",
    "Pink lavender",
    "Pink lace",
    "Platinum",
    "Plum",
    "Polished Pine",
    "Plump Purple",
    "Prune",
    "Portland Orange",
    "Psychedelic purple",
    "Princeton orange",
    "Pomp and Power",
    "Popstar",
    "Puce",
    "Pullman Brown",
    "Pumpkin",
    "Purple pizzazz",
    "Purple navy",
    "Purple",
    "Purple Plum",
    "Purpureus",
    "Purple mountain majesty",
    "Queen pink",
    "Raspberry glace",
    "Raisin black",
    "Quick Silver",
    "Quinacridone magenta",
    "Queen blue",
    "Radical Red",
    "Raspberry",
    "Rajah",
    "Razzle dazzle rose",
    "Raspberry rose",
    "Rebecca Purple",
    "Raw Sienna",
    "Red",
    "Raw umber",
    "Razzmatazz",
    "Razzmic Berry",
    "Red-orange",
    "Red-violet",
    "Red Salsa",
    "Red-purple",
    "Redwood",
    "Resolution blue",
    "Rhythm",
    "Rich black",
    "Rose pink",
    "Rose bonbon",
    "Rose",
    "Rose ebony",
    "Roman silver",
    "Robin egg blue",
    "Rose Dust",
    "Rifle green",
    "Rocket metallic",
    "Rose quartz",
    "Rose madder",
    "Rose red",
    "Rose taupe",
    "Russet",
    "Rubine red",
    "Ruber",
    "Royal yellow",
    "Russian green",
    "Royal blue",
    "Rufous",
    "Rosso corsa",
    "Rose vale",
    "Rosewood",
    "Rosy brown",
    "Royal purple",
    "Ruby",
    "Ruby red",
    "Rusty red",
    "Sacramento State green",
    "Russian violet",
    "Rust",
    "Saddle brown",
    "Saffron",
    "Sage",
    "Safety yellow",
    "Safety orange",
    "Sand dune",
    "Sapphire",
    "Salmon pink",
    "Salmon",
    "Salmon Magistrate",
    "St. Patrick's blue",
    "Sand",
    "Sap green",
    "Sapphire blue",
    "Scarlet",
    "Schauss pink",
    "Sandy brown",
    "Satin sheen gold",
    "School bus yellow",
    "Shocking pink",
    "Sea green",
    "Shadow blue",
    "Seashell",
    "Silver",
    "Screamin' Green",
    "Seal brown",
    "Shamrock green",
    "Shadow",
    "Sepia",
    "Selective yellow",
    "Shiny Shamrock",
    "Shimmering Blush",
    "Sheen green",
    "Sienna",
    "Sinopia",
    "Sizzling Red",
    "Silver chalice",
    "Silver sand",
    "Silver pink",
    "Sky magenta",
    "Skobeloff",
    "Sizzling Sunrise",
    "Sky blue",
    "Smoky black",
    "Slimy green",
    "Slate gray",
    "Slate blue",
    "Smitten",
    "Spanish bistre",
    "Solid pink",
    "Sonic silver",
    "Space cadet",
    "Snow",
    "Spanish orange",
    "Spanish blue",
    "Spanish carmine",
    "Spanish gray",
    "Spanish green",
    "Spanish pink",
    "Spanish sky blue",
    "Spring green",
    "Steel pink",
    "Steel Teal",
    "Straw",
    "Spanish red",
    "Spring bud",
    "Spring Frost",
    "Spanish viridian",
    "Spanish violet",
    "Steel blue",
    "Star command blue",
    "Stil de grain yellow",
    "Sunglow",
    "Sunray",
    "Sugar Plum",
    "Super pink",
    "Sunset",
    "Tango pink",
    "Tan",
    "Tangerine",
    "Taupe",
    "Tart Orange",
    "Tea rose",
    "Sweet Brown",
    "Taupe gray",
    "Tea green",
    "Tenné",
    "Telemagenta",
    "Teal",
    "Teal blue",
    "Tiffany Blue",
    "Tomato",
    "Tuscan",
    "Tumbleweed",
    "Thistle",
    "Tickle Me Pink",
    "Thulian pink",
    "Terra cotta",
    "Timberwolf",
    "Tropical rain forest",
    "Titanium yellow",
    "True Blue",
    "Turquoise",
    "Trypan Blue",
    "Tufts blue",
    "Turquoise blue",
    "Tuscan brown",
    "Turtle green",
    "Tuscan red",
    "Turquoise green",
    "Tuscany",
    "Ultra pink",
    "Unmellow yellow",
    "USAFA blue",
    "UA blue",
    "Twilight lavender",
    "Tuscan tan",
    "Tyrian purple",
    "Ultramarine",
    "UA red",
    "Ultramarine blue",
    "Ultra red",
    "Van Dyke brown",
    "Unbleached silk",
    "Umber",
    "United Nations blue",
    "Upsdell red",
    "UP Forest green",
    "Uranian blue",
    "UP maroon",
    "Vanilla",
    "Venetian red",
    "Violet",
    "Vanilla ice",
    "Verdigris",
    "Vermilion",
    "Veronica",
    "Vegas gold",
    "Vivid burgundy",
    "Viridian green",
    "Violet-blue",
    "Violet-red",
    "Vivid sky blue",
    "Viridian",
    "Volt",
    "Xanthic",
    "Wine dregs",
    "Wild orchid",
    "Wheat",
    "Warm black",
    "Vivid violet",
    "Vivid tangerine",
    "White",
    "Wild blue yonder",
    "Wild Strawberry",
    "Wild watermelon",
    "Windsor tan",
    "Wine",
    "Winter Sky",
    "Wintergreen Dream",
    "Wisteria",
    "Xanadu",
    "Wood brown",
    "Xiketic",
    "Yellow",
    "Yale Blue",
    "Zomp",
    "YInMn Blue",
    "Zaffre",
    "Yellow-green",
    "Yellow Sunshine",
    "Yellow Orange",
]


export const Constant = {
    gemStones: gemStones,
    colors: colors,
}

